module.exports = __webpack_public_path__ + "img/type5.422eaffb.png";